import { request } from '../../../../lib/request';
import { SUSHI_DATA_API_HOST } from 'sushi/config/subgraph';
import { graphql } from '../../graphql';
export const SushiV2BurnsQuery = graphql(`
query V2Burns($address: Bytes!, $chainId: SushiSwapV2ChainId!) {
  v2Burns(address: $address, chainId: $chainId) {
    id
    logIndex
    amountUSD
    amount1
    amount0
    liquidity
    sender
    transaction {
      createdAtBlock
      createdAtTimestamp
      id
    }
  }
}
`);
export async function getSushiV2Burns({ ...variables }, options) {
    const url = `https://${SUSHI_DATA_API_HOST}`;
    const result = await request({ url, document: SushiV2BurnsQuery, variables }, options);
    if (result) {
        return result.v2Burns;
    }
    throw new Error(`Failed to fetch burns for ${variables.chainId}`);
}
